import * as React from "react";
import { MetricCard } from "./MetricCard";
import { fetchDashboardSummary } from "../../store/features/dashboardSlice";
import { useDispatch, useSelector } from "react-redux";


function HeaderMetrics() {
  const dispatch = useDispatch();
  const { totalImportsInTransit, importsRequiringAttention, projectedToCloseThisWeek, status } = useSelector(
    (state) => state.dashboard
  );

  React.useEffect(() => {
    if (status === "idle") {
      dispatch(fetchDashboardSummary());
    }
  }, [status, dispatch]);

  if (status === "loading") return <div>Loading metrics...</div>;
  if (status === "failed") return <div>Failed to load metrics data.</div>;

  const metricsData = [
    {
      value: totalImportsInTransit,
      label: "Total imports in transit",
      borderColor: "border-sky-900",
      valueColor: "text-black",
    },
    {
      value: importsRequiringAttention,
      label: "Imports requiring attention",
      borderColor: "border-orange-600",
      valueColor: "text-orange-600",
    },
    {
      value: projectedToCloseThisWeek,
      label: "Projected to close this week",
      borderColor: "border-purple-500",
      valueColor: "text-black",
    },
  ];

  return (
    <section className="flex flex-wrap gap-6 items-center font-bold text-center">
      {metricsData.map(({ value, label, borderColor, valueColor }, index) => (
        <MetricCard
          key={index}
          value={value}
          label={label}
          borderColor={borderColor}
          valueColor={valueColor}
        />
      ))}
    </section>
  );
}

export default HeaderMetrics;
